import { type PropsWithChildren } from 'react'

type Props = {
  header: string;
  subheader?: string;
}

export default function QuoteInfoSection ({ header, subheader, children }: PropsWithChildren<Props>) {
  return (
    <div className='flex flex-col justify-center gap-6 bg-gray-50 p-6 rounded-lg'>
      <div className='flex flex-col gap-1'>
        <h1 className='text-sm text-gray-800'>
          {header}
        </h1>
        {subheader && (
          <p className='text-xs text-gray-500'>
            {subheader}
          </p>
        )}
      </div>
      {children}
    </div>
  )
}
